export default __webpack_public_path__ + "static/media/back-icon.c506696b.svg";